import appConfig from '@/config/appConfig.typed';

type OneTrustGlobals = Window & {
    OnetrustActiveGroups?: string;
};

type OneTrustConsentListener = {
    fn: (allowed: boolean) => void;
    groupIds: string[];
};

const listeners = new Set<OneTrustConsentListener>();

export const isOneTrustConsentGatingEnabled = () => Boolean(appConfig.getOneTrustDomainScriptId());

const getActiveOneTrustGroupIds = () => {
    const raw = (window as OneTrustGlobals).OnetrustActiveGroups;

    if (!raw || typeof raw !== 'string') return [];

    return raw
        .split(',')
        .map((value) => value.trim())
        .filter(Boolean);
};

export const computeOneTrustConsentAllowed = (groupIds: string[]) => {
    if (!isOneTrustConsentGatingEnabled()) return true;
    if (!groupIds.length) return false;

    const activeGroups = new Set(getActiveOneTrustGroupIds());

    return groupIds.some((id) => activeGroups.has(id));
};

export const notifyOneTrustConsentUpdated = () => {
    listeners.forEach(({fn, groupIds}) => {
        fn(computeOneTrustConsentAllowed(groupIds));
    });
};

export const subscribeOneTrustConsent = (fn: (allowed: boolean) => void, groupIds: string[]): (() => void) => {
    const listener = {fn, groupIds: [...groupIds]};

    listeners.add(listener);
    fn(computeOneTrustConsentAllowed(listener.groupIds));

    return () => listeners.delete(listener);
};
